import React from "react";
import Header from "./headerRelative";
import Footer from "./footer";
import SeparatorGraphic from "./separatorGraphic";
import "./styles/loading.css";

function LoadingPage({ message = "Loading content...", showHeader = true, showFooter = true }) {
  return (
    <div>
      {showHeader && (
        <>
          <Header />
          <SeparatorGraphic />
        </>
      )}
      <main className="loading-container">
        <div className="loading-content">
          <div className="loading-spinner-container">
            <svg className="loading-spinner" viewBox="0 0 50 50">
              <circle
                className="loading-spinner-circle"
                cx="25"
                cy="25"
                r="20"
                fill="none"
                strokeWidth="4"
              />
            </svg>
          </div>
          <h2 className="textBold loading-text">{message}</h2>
        </div>
      </main>
      {showFooter && (
        <>
          <SeparatorGraphic />
          <Footer />
        </>
      )}
    </div>
  );
}

export default LoadingPage; 